<template>
	<div class="basic_wrap">
		<!-- 顶部红色背景栏，包含返回和消息按钮 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('home.item')}}</div>
			<div class="msg" @click="$router.push('/notice')">
				<img src="../images/invest/msg.png">
			</div>
		</div>

		<!-- 产品标签和列表 -->
		<div class="item_wrap">
			<div class="tabs">
				<div class="tabs-head">
					<div class="tabs-head-scroll">
						<!-- 标签项循环 -->
						<div class="tab-item" :class="active==index?'tab-item-active':''" v-for="(item,index) in tabs1"
							@click="sort(index)">
							<div class="tab-icon">
								<img :src="item.icon" alt="">
							</div>
							<div class="tab-title">
								{{item.title}}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="items_3 item_margin">
						    <!-- 若无数据则显示空状态 -->
						    <van-empty v-if="listLength == 0" :description="$t('item.noData')" />
						
						    <!-- 产品列表 -->
						    <!-- 
						      修改点1：将 data1.list 改为 filteredList
						      说明：现在使用计算属性 filteredList 来控制显示哪些产品，
						      该计算属性已经包含了基于 guarantee 和 class 的完整筛选逻辑
						    -->
						    <div v-for="i in filteredList" :key="i.id" class="item">
						        <!-- 
						          修改点2：移除 v-if="i.class*1 != proshow && i.class*1 < proshow1" 条件
						          说明：筛选逻辑已转移到计算属性中，此处不再需要条件判断
						        -->
						        <div class="item-if">
						            <!-- 左侧图片部分 - 保持不变 -->
						            <template class="disflex1">
						                <div class="item_div0" @click="$router.push('/item/' + i.id)">
						                    <!-- 优先显示 cover 图片 -->
						                    <img v-if="i.cover" class="icon" :src="i.cover" alt="" style="width: 15px; height: 15px;">
						                    <!-- 没有 cover 时显示 img 图片（自动添加 https:// 前缀） -->
						                    <img v-else class="icon" :src="'https://' + i.img" alt="">
						                </div>
						            </template>
						            
						            <!-- 右侧文本部分 - 保持不变 -->
						            <template class="disflex2">
						                <div class="disflex2-div" @click="buy(i)">
						                    <!-- 产品名称（根据当前语言显示） -->
						                    <div class="item_div1">
						                        <p>{{ i[lang] }}</p>
						                    </div>
						                    
						                    <!-- 投资金额 -->
						                    <div class="item_div2">
						                        <div class="item_min">
						                            <p><span>{{$t('utils.money')}}：</span>{{i.min}}</p>
						                        </div>
						                    </div>
						                    
						                    <!-- 投资周期 -->
						                    <div class="item_div3">
						                        <p><span>{{$t('utils.cycle')}}：</span>{{i.day}}{{$t('utils.day')}}</p>
						                    </div>
						                    
						                    <!-- 浮动利润（根据结算周期显示不同计算方式） -->
						                    <div class="item_div4">
						                        <!-- 到期结算模式 -->
						                        <div class="item_rate" v-if="i.settlement_cycle=='end'">
						                            <p>
						                                <span>{{$t('utils.FloatingProfit')}}：</span>
						                                {{i.min*1+i.rate_min*1}} - {{i.min*1+i.rate_max*1}}
						                            </p>
						                        </div>
						                        <!-- 每日结算模式 -->
						                        <div class="item_rate" v-else-if="i.settlement_cycle=='daily'">
						                            <p>
						                                <span>{{$t('utils.dailyProfit')}}：</span>
						                                {{i.rate_min}} - {{i.rate_max}}
						                            </p>
						                        </div>
						                    </div>
						                    
						                    <!-- 库存数量（显示剩余库存百分比） -->
						                    <div class="item_div5">
						                        <p><span>{{$t('utils.StockQuantity')}}：</span>{{i.stock*i.percent}}</p>
						                    </div>
						                    
						                    <!-- 租赁次数 -->
						                    <div class="item_div6">
						                        <p><span>{{$t('utils.NumberOfRentals')}}：</span>{{i.num}}</p>
						                    </div>
						                </div>
						            </template>
						        </div>
						        
						        <!-- 按钮区域 - 同样移除 class 相关的 v-if 条件 -->
						        <div class="item-if">
						            <!-- 左侧按钮：查看详情 -->
						            <template>
						                <div class="item_div_B1">
						                    <div @click="$router.push('/item/' + i.id)" class="Button">
						                        <p>{{$t('notice.detail')}}</p>
						                    </div>
						                </div>
						            </template>
						            
						            <!-- 右侧按钮：立即投资 -->
						            <template>
						                <div class="item_div_B2">
						                    <div @click="buy(i)" class="Button">
						                        <p>{{$t('utils.submit')}}</p>
						                    </div>
						                </div>
						            </template>
						        </div>
						    </div>
						</div>

			<!-- 投资对话框 -->
			<van-dialog v-model="show_tz" theme="round-button" @confirm="confirm" :confirmButtonText="$t('utils.confirm')">
				<div class="close-x" @click="show_tz = false">
					<van-icon name="cross" class="van-icon van-icon-cross" />
				</div>
				<div class="show-body">

					<div class="sw-cell">
						<!-- 产品名称 -->
						<div class="sw-label">{{ sku[lang] }}</div>

						<!-- 金额 -->
						<div class="sw-bar">
							<div class="flex_bd">
								<van-field :value="this.showmin" disabled />
							</div>
							<div class="ut">ZAR</div>
						</div>

					</div>

					<div class="sw-grid">
						<div class="flex_bd">
							<div class="sw-row">
								<div class="sw-info">{{$t('utils.yuji_sy')}}</div>
							</div>
							<div class="sw-row">
								<div class="sw-val text-green">{{sku.min*1+sku.rate_min*1}} - {{sku.min*1+sku.rate_max*1}} [ZAR]</div>
							</div>
							
							<!-- 显示每日收益？ -->
							<div class="sw-row" v-if="sku.settlement_cycle=='daily'">
								<div class="sw-info">{{$t('utils.daily_sy')}}</div>
							</div>
							<div class="sw-row" v-if="sku.settlement_cycle=='daily'">
								<div class="sw-val text-green">{{sku.rate_min}} - {{sku.rate_max}} [ZAR]</div>
							</div>
							
						</div>

						<div class="sw-right">
							<div class="sw-label">ZAR</div>
							<div class="sw-lg">{{sku.day}}{{$t('utils.day')}}</div>
							<div class="sw-info">{{$t('utils.cycle')}}</div>
						</div>
					</div>
				</div>
			</van-dialog>
		</div>

		<!-- VIP 等级不足时的提示弹窗 -->
		<van-overlay :show="show1" @click="show1 = false">
			<div class="wrapper" @click.stop>
				<div class="block">{{$t('utils.novip')}}</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import Vue from 'vue';
	import {
		Tab,
		Tabs,
		Progress,
		Empty,
		Dialog,
		Field,
		Sticky,
		Switch,
		Overlay,
		Icon
	} from 'vant';

	// 注册 Vant 组件
	Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Sticky).use(Switch).use(Overlay).use(Icon);

	export default {
		name: "item",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				tabs: [
					this.$t('item.all'),
					this.$t('item.tab3')
				],
				// 产品类别配置
				tabs1: [
				{
					icon: require('../images/invest/icon3.png'),
					title: this.$t('item.tab7')
				}, {
					icon: require('../images/invest/icon2.png'),
					title: this.$t('item.tab3')
				},
				],
				active: 0,  // 当前激活的标签索引
				auto_close: [],
				data1: [],
				listLength: 0,
				show_tz: false,  // 控制投资对话框显示
				number: "",
				sku: [],
				checked: true,
				showmin:"",  // 显示的最小金额

				vipdata:"",
				proshow:0,
				proshow1:132,

				// 本地语言
				loclal:"",
				skdeta:"",
				sx:"",
				
				// VIP 等级不足时显示
				show1:false,
			}
		},
		computed: {
				    filteredList() {
				        if (!this.data1.list) return [];
				        
				        return this.data1.list.filter(item => {
				            const guarantee = parseInt(item.guarantee) || 0;
				            const itemClass = parseInt(item.class) || 0;
		
				            // 特殊区域标签页
				            if (this.active === 1) {
				                return guarantee === 1 ||          // 强制显示在特殊区
				                      (guarantee === 2 && itemClass >= 133); // guarantee=2且class≥133
				            }
				            
				            // 普通区域标签页
				            return guarantee === 0 ||             // 强制显示在普通区
				                   (guarantee === 2 && itemClass <= 132); // guarantee=2且class≤132
				        });
				    }
				},
		methods: {
			// 获取客户的 VIP 状态
			vipstate() {
				Fetch('/user/info').then((r) => {
					this.vipdata = r.data.vip_name;
				});
			},

			// 获取产品列表
			start() {
				Fetch('/index/item_search', {
					name: "",
					index_type:0
				}).then(r => {
					this.data1 = r.data;
					this.listLength = r.data.list.length;
				})
			},
			
			// 点击切换产品列表
			sort(type) {
			        this.active = type;
			        // 保持原有proshow/proshow1设置（兼容性）
			        this.proshow = type === 0 ? 0 : 131;
			        this.proshow1 = type === 0 ? 132 : 200;
			        this.updateListLength();
			    },
			
			// 改变自动投资状态
			changeAuto(e) {
				console.log(e)
				Fetch("/index/item_auto_c", {
				  pid: this.sku.id,
				  tz_auto: this.checked?1:0
				}).then(r => { 
				}).catch(err=>{
				    this.psd_val = '';
				})
			},

			// 购买产品
			buy(item) {
				this.sku = item;
				
				if (this.auto_close.indexOf(item.id) != -1) {
					this.checked = false;
				} else {
					this.checked = true;
				}
				this.show_tz = true;

				this.showmin = item.min
			},

			// 确认购买
			confirm() {
				let loclal = this.$i18n.locale;
			
				// 检查 VIP 等级
				if (this.vipdata.slice(-1) >= this.sku.class_details[loclal].slice(-1)) {
					if (!this.showmin) {
						this.$toast({
							className:"toastName",
							message: this.$t('item.inputAmount'),
						});
						return false;
					}
					Fetch("/index/item_apply", {
						id: this.sku.id,
						money: this.showmin
					}).then(r => {
						this.$router.push("/order");
					}).catch(err => {
					})
				}else{
					this.show1 = true
				}
			}
		},

		mounted() {
			// 获取客户 VIP 状态
			this.vipstate()
		
			var type = 0;
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			
			// 获取产品列表
			this.start();
		},

		created() {
			this.$parent.footer('item');
		}	
	}
</script>

<style lang="less" scoped>
	/deep/ .van-cell {
		padding: 15px 26px;
	}

	.tabs {
		background-color: #fff;
		border-bottom: 1px solid #ececec;
		width: 100%;
	}

	.tabs-head {
		// height: 73px;
		overflow: hidden;
		position: relative;

		.tabs-head-scroll {
			width: 100%;
			white-space: nowrap;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tab-item {
				display: inline-block;
				text-align: center;
				width: 50%;
				padding: 10px;
				margin-left: 5px;
				margin-right: 5px;
				border-radius: 10px;
				.tab-icon {
					height: 51px;
					img {
						height: 100%;
					}
				}
				.tab-title {
					padding: 5px 0;
					color: #666666;
				}
			}
			.tab-title {
					color: #333333;
				}
			.tab-item-active {
				background-color: rgb(255, 116, 72);
				.tab-title {
					color: #fff !important;
				}
			}
		}
	}
	.red_top_bg {
		top: 0;
		z-index: 10;
		background-image: linear-gradient(to right, #ff5252, #ff8244);

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;
			img {
				height: 100%;
			}
		}
	}
	.basic_wrap {
		position: relative;
		.wrapper{

				width: 60vw;
				height: 20vh;
				background-color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 10px;
				position: fixed;
				top: 40%;
				left: 50%;
				transform: translate(-50%,-40%);

			.block {
				width: 60vw;
				height: 20vh;
				background-color: #fff;
				border-radius: 10px;
				font-size: 18px;
				vertical-align:middle;
				
				text-align: center;
				display: flex;
				justify-content: center;
				align-items: center;
				padding-right: 2vw;
				padding-left: 2vw;
				font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
				line-height: 1.5;
				color: #999;
				font-weight: bold;
			}
		}	
	}
	.item_wrap {
		width: 100%;
		.tabs {
			z-index: 100;
			margin-top: 5px;
		}
		.items_3{
			margin:0 5px;
		}
	}
	.items_3 {
		margin: 10px 15px;
		.item {
			background: #FFFFFF;
			margin-top: 5px;
			margin-bottom: 5px;
			border-radius: 10px;
			.item-if{
				background: #FFFFFF;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				width: 100%;
				height: 100%;
				border-radius: 10px;
			}	
					// 左边图片样式
					.item_div0{
						width: auto;
						height: auto;
						width: 150px;
						height: 150px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-left: 3%;

						img{
							width: auto;
							height: auto;
							width: 100%;
							height: 100%;
						}
					}
					// 左边按钮样式
					.item_div_B1{
						width: 150px;
						display: flex;
						justify-content: center;
						margin-left: 3%;
					
					}
					// 右边按钮样式
					.item_div_B2{
						width: 150px;
						margin-left: 5%;
						margin-bottom: 10px;
						margin-top: 10px;
						border-radius: 10px;
						
					}
					.Button {
						display: flex;
						align-items: center;
						justify-content: center;
						border-radius: 5px;
						background-image: linear-gradient(to right, #ff9797, #ff9797);
						box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
						color: #fff;
						font-size: 12px;
						padding: 10px;
						
					}
					// 右边样式
					.disflex2-div{
						display: flex;
						flex-direction: column;
						justify-content: flex-start;
						margin-left: 5%;
						overflow: hidden;
						margin-bottom: 10px;
						margin-top: 10px;
						border-radius: 10px;
						font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Segoe UI,Arial,Roboto,PingFang SC,miui,Hiragino Sans GB,Microsoft Yahei,sans-serif;
						span{
						color: #999;
						}
						p{
						color: #f44844;
						line-height: 1.5;
						}
							// 产品名称
						.item_div1{
							font-size: 13px;
							font-weight: bolder;
							margin-top: 4px;
							margin-bottom: 4px;
							margin-left: 0;
							margin-right: 0;
							p{
								color: #000;
							}
						}
					}
					.disflex2-div > div{
							margin-top: 4px;
							margin-bottom: 4px;
							margin-left: 0;
							margin-right: 0;
					}
				
		}
	}
	/deep/ .van-tabs__line {
		height: 2px;
		background-color: #1989fa;
	}

	/deep/ .van-tab--active {
		color: #1989fa;
	}

	.close-x{
		width: 100%;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: end;
		padding-right: 10px;
		margin-top: 10px;

	}

	.show-body {
		padding: 20px;
		font-size: 14px;

		.sw-label {
			margin-bottom: 10px;
			font-size: 18px;
			font-weight: bold;

			
		}

		.sw-bar {
			display: flex;
			align-items: center;
			background-color: #f5f5f5;
			padding: 10px;
			border-radius: 4px;

			.flex_bd {
				color: #999999;
			}
		}

		.sw-cell{

			.sw-label{
				text-align: center;
				font-weight: bold;
			}

			.sw-bar{
				justify-content: center;

				div{

					margin: 5px;
					font-size: 20px;
					color: #999;
					font-weight: bold;
				}

				.ut{
					font-weight: bold;
				}
			}
		}
	}

	.sw-bar .van-cell {
		padding: 0;
		background-color: transparent;
	}

	.sw-grid {
		display: flex;
		align-items: flex-end;
		margin-top: 20px;

		.sw-row:first-child {
			margin-bottom: 25px;
		}

		.sw-row>div:first-child {
		}

		.sw-info {
			color: #999;
			font-size: 18px;
		}

		.sw-val.text-green {
			font-size: 20px;
			font-weight: bold;

		}
	}

	.sw-right {
		text-align: center;

		.sw-lg {
			font-size: 18px;
			margin-bottom: 10px;
			
		}
		.sw-label{
			font-size: 18px;
			font-weight: bold;
			font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;

		}
	}

	.flex_bd {
		display: flex;
		flex-direction: column;
		justify-content:space-between;
		
		flex: 1;
	}
	
	
</style>
